/** @format */

'use client';
import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';

const CategoryBannerSkeleton = () => {
  return <Skeleton className='h-60 w-full md:h-80 lg:h-96' />;
};

export default CategoryBannerSkeleton;
